import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as reviewsActions from '../../actions/reviewsActionCreators';
import {withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import SeoTags from '../../routes/SeoTags';
import constants from '../../constants';
import ReviewForm from '../../components/ReviewForm';

const CreateReviewPage = (props) => {
  const
    {newReview} = props.reviewsState;

  return (
    <Layout
      className='reviews-page'
      breadcrumbs={[
        {label: 'Отзывы', path: constants.ROUTES.REVIEWS_PATH},
        {label: 'Оставить отзыв'}
      ]}
    >
      <SeoTags
        controller_action='reviews#new'
      />

      <div className='container'>
        <ReviewForm />
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      reviewsActions: bindActionCreators(reviewsActions, dispatch)
    };
  },

  mapStateToProps = ({reviewsState, railsContext, applicationState}) => {
    return {
      applicationState,
      reviewsState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(CreateReviewPage));
